import { Injectable, TransferState } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiServerService {
  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private state: TransferState) {}

  /***
   * GET
   */
  GET<T>(url: string, queryParams?: string): Observable<T> {
    let getUrl = this.apiUrl + url;
    if (queryParams) getUrl += '?' + queryParams;
    return this.http.get<T>(getUrl, { withCredentials: environment.production });
  }

  /***
   * PATCH
   */
  PATCH<T>(url, body): Observable<T> {
    const patchUrl = this.apiUrl + url;
    return this.http.patch<T>(patchUrl, body, { withCredentials: environment.production });
  }

  /***
   * PUT
   */
  PUT<T>(url, body): Observable<T> {
    const patchUrl = this.apiUrl + url;
    return this.http.put<T>(patchUrl, body, { withCredentials: environment.production });
  }

  /***
   * POST
   */
  public POST<T>(url: string, body: any): Observable<T>;
  public POST<T>(url: string, body: any, options: { observe: 'body'; } & any): Observable<T>;
  public POST<T>(url: string, body: any, options: { observe: 'events'; reportProgress: boolean; } & any): Observable<HttpEvent<T>>;
  public POST<T>(url: string, body: any, options?: any): Observable<any> {
    const postUrl = this.apiUrl + url;
    const defaultOptions = {
      withCredentials: environment.production,
    };

    const mergedOptions = {
      ...defaultOptions,
      ...options
    };

    return this.http.post<T>(postUrl, body, mergedOptions);
  }

  DELETE<T>(url: string): Observable<T> {
    const deleteUrl = this.apiUrl + url;
    return this.http.delete<T>(deleteUrl);
  }

  UPLOAD<T>(url, data, headers?) {
    const uploadUrl = this.apiUrl + url;
    return this.http
      .post<T>(uploadUrl, data, {
        reportProgress: true,
        observe: 'events',
        headers,
      })
      .pipe(
        map((event) => {
          console.log('event:', event);
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = Math.round((100 * event.loaded) / event.total);
              return { status: 'progress', message: progress };

            case HttpEventType.Response:
              return event.body;
            default:
              return `Unhandled event: ${event.type}`;
          }
        }),
      );
  }
}
